// Variable paths for CRM Email Activity trigger
export const CrmEmailActivityCampaignIDPath = '{.activity_data.FieldID-96b1b1b8-6534-4b2c-a974-5c45cf05e556}';
export const CrmEmailActivityStatusPath = '{.activity_data.FieldID-5a15fea4-cc20-498c-a55b-97938775f00e}';

// Campaign Owner Types
export enum CampaignOwner {
  Any = '*',
  Marketing = 'marketing',
  Yesware = 'yesware',
}
export type CampaignOwnerType = '*' | 'marketing' | 'yesware';

// Email Status Types. Marketing refers to our internal marketing campaigns, while Yesware refers to the Yesware campaigns.
// EmailStatus is used when the Status can be either type.
export enum MarketingEmailStatus {
  Sent = 'sent',
  Opened = 'opened',
  Clicked = 'clicked',
  Unsubscribed = 'unsubscribed',
  Bounced = 'bounced',
  Dropped = 'dropped',
}
export type MarketingEmailStatusType = 'sent' | 'opened' | 'clicked' | 'unsubscribed' | 'bounced' | 'dropped';

export enum YeswareEmailStatus {
  Send = 'send',
  Opened = 'opened',
  Clicked = 'clicked',
  Reply = 'reply',
}
export type YeswareEmailStatusType = 'send' | 'opened' | 'clicked' | 'reply';

export enum EmailStatus {
  Any = '*',
  CombinedSent = 'combined_sent',
  Opened = 'opened',
  Clicked = 'clicked',
  Unsubscribed = 'unsubscribed',
  Bounced = 'bounced',
  Dropped = 'dropped',
  Reply = 'reply',
}
export type EmailStatusType = '*' | 'combined_sent' | MarketingEmailStatusType | YeswareEmailStatusType;

// Email Status Options
// Our internal campaign email status types are different from Yesware's.
// This function maps the status types to their corresponding display names.
export const GetEmailStatusOptions = (campaignType: CampaignOwnerType): Map<EmailStatusType, string> => {
  const options = new Map<EmailStatusType, string>([
    [EmailStatus.Any, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.ANY'],
  ]);

  switch (campaignType) {
    case CampaignOwner.Marketing:
      options.set(MarketingEmailStatus.Sent, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.SENT');
      options.set(MarketingEmailStatus.Opened, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.OPENED');
      options.set(MarketingEmailStatus.Clicked, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.CLICKED');
      options.set(
        MarketingEmailStatus.Unsubscribed,
        'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.UNSUBSCRIBED',
      );
      options.set(MarketingEmailStatus.Bounced, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.BOUNCED');
      options.set(MarketingEmailStatus.Dropped, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.DROPPED');
      break;
    case CampaignOwner.Yesware:
      options.set(YeswareEmailStatus.Send, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.SENT');
      options.set(YeswareEmailStatus.Opened, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.OPENED');
      options.set(YeswareEmailStatus.Clicked, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.CLICKED');
      options.set(YeswareEmailStatus.Reply, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.REPLIED');
      break;
    default:
      options.set(EmailStatus.CombinedSent, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.SENT');
      options.set(EmailStatus.Opened, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.OPENED');
      options.set(EmailStatus.Clicked, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.CLICKED');
      options.set(EmailStatus.Reply, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.REPLIED');
      options.set(EmailStatus.Unsubscribed, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.UNSUBSCRIBED');
      options.set(EmailStatus.Bounced, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.BOUNCED');
      options.set(EmailStatus.Dropped, 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.DROPPED');
      break;
  }

  return options;
};
